// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mbsc-ios.mbsc-textfield-wrapper-box,\n.mbsc-ios.mbsc-textfield-wrapper-outline {\n  margin: 0;\n}\n\n.mbsc-range-start .mbsc-range-label-clear.active {\n  display: none;\n}\n\n.mbsc-textfield-tag {\n  padding-right: 0.75em;\n}\n\n.mbsc-textfield-tag-clear {\n  display: none;\n  margin-right: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
